import React from 'react';
import * as shapes from '../../../../common/shapes';

const Label = ({ children }) => (
  <div className="c-label">
    {children}
  </div>
);
Label.propTypes = { children: shapes.children.isRequired };

export default Label;
